import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./feature/simulador/simulador.module').then(
        (m) => m.SimuladorModule
      ),
  },
  {
    path: 'campana-comojubilar',
    loadChildren: () =>
      import('./feature/simulador/simulador.module').then(
        (m) => m.SimuladorModule
      ),
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  scrollOffset: [0, 80],
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
